<template>
  <div
    style="max-width: 1200px;"
    class="mx-auto p-2 "
    dir="ltr"
  >
    <b-card
      class="p-3"
      style="text-align: left;"
      v-html="text"
    />
  </div>
</template>

<script >
import AgreementRegister from '@/views/logics/auth/AgreementRegister'

export default {
  mixins: [AgreementRegister],
}

</script>
